"use strict";
import { jsx, jsxs } from "react/jsx-runtime";
import ReactUtils from "../../react_utils";
var bem = ReactUtils.makeBem("pod-shipment-selector");
function linkedDocumentsLabel(selectedDocuments) {
  if (selectedDocuments.length == 0) {
    return null;
  } else if (selectedDocuments.length == 1) {
    const docType = selectedDocuments[0].type_name;
    return /* @__PURE__ */ jsxs("span", { className: bem("__linked-documents"), children: [
      docType,
      " linked"
    ] });
  } else {
    return /* @__PURE__ */ jsxs("span", { className: bem("__linked-documents"), children: [
      selectedDocuments.length,
      " Docs linked"
    ] });
  }
}
function shipmentSelector(props, shipmentDocumentSelection) {
  const shipment = shipmentDocumentSelection.shipment;
  const selectedDocuments = shipmentDocumentSelection.documents;
  const isChecked = selectedDocuments.some(
    (doc) => doc.id == props.selectedDocument.id
  );
  let shipmentLabel = shipment.shipment_external_id;
  if (shipment.customer_name) {
    shipmentLabel += ` for ${shipment.customer_name}`;
  }
  return /* @__PURE__ */ jsxs(
    "li",
    {
      className: bem("__list-item"),
      onClick: () => props.toggleShipmentDocument(shipment.id, props.selectedDocument),
      children: [
        /* @__PURE__ */ jsx(
          "input",
          {
            type: "checkbox",
            checked: isChecked,
            className: bem("__checkbox")
          }
        ),
        /* @__PURE__ */ jsxs("label", { className: bem("__label"), children: [
          shipmentLabel,
          linkedDocumentsLabel(selectedDocuments)
        ] })
      ]
    },
    shipment.id
  );
}
export default function IndexingShipmentSelector(props) {
  return /* @__PURE__ */ jsxs("div", { className: "pod-shipment-selector", children: [
    /* @__PURE__ */ jsx("h3", { className: bem("__title"), children: "Link customer docs to shipments" }),
    /* @__PURE__ */ jsx("ul", { className: bem("__list"), children: props.shipmentDocumentSelections.map((shipmentDocumentSelection) => {
      return shipmentSelector(props, shipmentDocumentSelection);
    }) })
  ] });
}
